import { useRef, useLayoutEffect, } from 'react';
export function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        if (!timer) {
            func.apply(this, args);
        }
        clearTimeout(timer);
        timer = setTimeout(() => {
            timer = undefined;
        }, timeout);
    };
}
export const throttle = (func, delay) => {
    let prev = 0;
    return (...args) => {
        const now = new Date().getTime();
        if (now - prev > delay) {
            prev = now;
            return func(...args);
        }
    };
};
export function isDef(val) {
    return val !== undefined && val !== null;
}
export function isFunc(val) {
    return typeof val === 'function';
}
export function isArr(val) {
    return Array.isArray(val);
}
export function isObj(val) {
    return Object.prototype.toString.call(val) === '[object Object]';
}
export function judgeObj(obj) {
    if (!obj || Object.prototype.toString.call(obj) !== '[object Object]' || JSON.stringify(obj) === '{}') {
        return false;
    }
    return true;
}
export function judgeArr(arr) {
    if (!arr || Object.prototype.toString.call(arr) !== '[object Array]' || JSON.stringify(arr) === '[]') {
        return false;
    }
    return true;
}
export function useClosure(fn) {
    const capture = useRef();
    let captureState = capture.current;
    if (!captureState) {
        captureState = {
            captureEffect() {
                funcProxy.target = captureState.workInProgressFn;
            },
            workInProgressFn: fn,
            closure: {
                proxy: ((...args) => funcProxy.target(...args)),
                target: fn,
            },
        };
        const funcProxy = captureState.closure;
        capture.current = captureState;
    }
    else {
        captureState.workInProgressFn = fn;
    }
    useLayoutEffect(captureState.captureEffect);
    return captureState.closure.proxy;
}
